// extracted by mini-css-extract-plugin
export var actionButton = "_in-t";
export var buttonContainer = "_in-0";
export var buttonContainer2 = "_in-1";
export var buttonSection = "_in-2";
export var details = "_in-3";
export var dropdownItem = "_in-5";
export var dropdownItemsContainer = "_in-4";
export var fileInput = "_in-r";
export var headerButton = "_in-6";
export var icon = "_in-7";
export var input = "_in-8";
export var macroListItem = "_in-9";
export var mainContent = "_in-a";
export var microText = "_in-b";
export var modal = "_in-w";
export var optionsButton = "_in-c";
export var paperclip = "_in-s";
export var pillContent = "_in-d";
export var preview = "_in-e";
export var preview2 = "_in-f";
export var quillEditor = "_in-q";
export var selectedMacro = "_in-g";
export var sidebar = "_in-h";
export var sidebarHeader = "_in-j";
export var sidebarList = "_in-i";
export var sidebarListItem = "_in-k";
export var sidebarSearch = "_in-l";
export var snoozeDurationWrapper = "_in-v";
export var statusPillContainer = "_in-m";
export var tagsContainer = "_in-n";
export var unselectedMacro = "_in-o";
export var variable = "_in-u";
export var wrapper = "_in-p";